import dayjs from 'dayjs';

const QUARTER_DIVISOR = 3;
export const MILLISECONDS_PER_SECOND = 1_000;
export const SECONDS_PER_MINUTE = 60;

const CURRENT_DATE = new Date();
export const CURRENT_YEAR = CURRENT_DATE.getFullYear();
export const CURRENT_QUARTER = Math.floor(
  (CURRENT_DATE.getMonth() + QUARTER_DIVISOR) / QUARTER_DIVISOR,
);
export const MIN_CALENDAR_DATE = '1900-01-01'; // Firefox doesn't convert date format 'MM-DD-YYYY' to 'MM/DD/YYYY'
export const MAX_CALENDAR_DATE = '2100-01-01'; // Firefox doesn't convert date format 'MM-DD-YYYY' to 'MM/DD/YYYY'
export const TODAY_IN_DAYS = dayjs().startOf('day');
export const YESTERDAY_IN_DAYS = dayjs().add(-1, 'day').startOf('day');

export const NUMBER_MONTHS_IN_YEAR = 12;
export const CALENDAR_STEP_SIZE = '00:30:00';

export const COMMON_DATE_FORMAT = 'MM/DD/YYYY';
export const COMMON_DATETIME_FORMAT = `${COMMON_DATE_FORMAT} h:mm A`;
export const COMMON_DATETIME_WITH_SECONDS_FORMAT = `${COMMON_DATE_FORMAT} HH:mm:ss`;
export const COMMON_DATETIME_FORMAT_FOR_FILE_NAME = 'MM-DD-YYYY-h-mm-A';
export const COMMON_DATETIME_FORMAT_FOR_TREE_ITEM = 'M/D/YYYY h:mm A';
export const COMMON_DATETIME_WITH_ZONE_FORMAT = `${COMMON_DATETIME_FORMAT_FOR_TREE_ITEM} z`;
export const LAST_UPDATED_DATE_FORMAT = 'MMMM[,] D YYYY [at] h:mm A';
export const LONG_DATE_FORMAT = 'MMMM D, YYYY';

export const CENTRAL_TIME_ZONE = 'America/Chicago';
export const EASTERN_TIME_ZONE = 'America/New_York';

export const SHORT_TIME_FORMAT = 'h:mm A';
export const SHORT_DATETIME_FORMAT = 'MMM D, h:mm A';
export const SHORT_MONTH_DAY_FORMAT = 'MMM D';
export const SHORT_MONTH_DAY_YEAR_FORMAT = 'MMM D, YYYY';
export const WEEKDAY_MONTH_DAY_FORMAT = 'dddd, MMM D';
export const WEEKDAY_MONTH_DAY_YEAR_FORMAT = 'dddd, MMM D, YYYY';

// BE format (not view)
export const CALENDAR_LOCAL_TIME_DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ssZ';
export const COMMON_REQUEST_DATE_FORMAT = 'YYYY-MM-DD';
export const COMMON_REQUEST_DATETIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss';

export const TOMORROW_DATE = dayjs().add(1, 'day');
export const END_OF_CURRENT_YEAR_DATE = dayjs().endOf('year');

export const DAYS_OF_WEEK = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];
export const FIRST_DAY_OF_MONTH = 1;
